import { Airport } from "@/models/airport";

// Stubbed airport list for building the Daily Service UI before the API
// exists. Daily departure counts are placeholder numbers.
const airport = (
  id: number,
  iata: string,
  name: string,
  city: string,
  country_code: string,
  country_name: string,
  country_emoji: string,
  lat: number,
  lon: number,
  daily_departures: number
): Airport => ({
  id,
  iata,
  name,
  city,
  country_code,
  country_name,
  country_emoji,
  lat,
  lon,
  daily_departures,
  municipality: city,
  state_name: "",
  timezone: "",
});

export const stubAirports: Airport[] = [
  airport(1, "LHR", "London Heathrow", "London", "GB", "United Kingdom", "🇬🇧", 51.47, -0.4543, 650),
  airport(2, "LGW", "London Gatwick", "London", "GB", "United Kingdom", "🇬🇧", 51.1537, -0.1821, 380),
  airport(3, "STN", "London Stansted", "London", "GB", "United Kingdom", "🇬🇧", 51.885, 0.235, 250),
  airport(4, "MAN", "Manchester", "Manchester", "GB", "United Kingdom", "🇬🇧", 53.3537, -2.275, 270),
  airport(5, "EDI", "Edinburgh", "Edinburgh", "GB", "United Kingdom", "🇬🇧", 55.95, -3.3725, 180),
  airport(6, "DUB", "Dublin", "Dublin", "IE", "Ireland", "🇮🇪", 53.4213, -6.2701, 330),
  airport(7, "CDG", "Paris Charles de Gaulle", "Paris", "FR", "France", "🇫🇷", 49.0097, 2.5479, 620),
  airport(8, "ORY", "Paris Orly", "Paris", "FR", "France", "🇫🇷", 48.7262, 2.3652, 300),
  airport(9, "NCE", "Nice Côte d'Azur", "Nice", "FR", "France", "🇫🇷", 43.6584, 7.2159, 190),
  airport(10, "AMS", "Amsterdam Schiphol", "Amsterdam", "NL", "Netherlands", "🇳🇱", 52.3105, 4.7683, 640),
  airport(11, "BRU", "Brussels", "Brussels", "BE", "Belgium", "🇧🇪", 50.901, 4.4844, 280),
  airport(12, "FRA", "Frankfurt", "Frankfurt", "DE", "Germany", "🇩🇪", 50.0379, 8.5622, 610),
  airport(13, "MUC", "Munich", "Munich", "DE", "Germany", "🇩🇪", 48.3538, 11.7861, 450),
  airport(14, "BER", "Berlin Brandenburg", "Berlin", "DE", "Germany", "🇩🇪", 52.3667, 13.5033, 290),
  airport(15, "ZRH", "Zurich", "Zurich", "CH", "Switzerland", "🇨🇭", 47.4582, 8.5555, 360),
  airport(16, "GVA", "Geneva", "Geneva", "CH", "Switzerland", "🇨🇭", 46.2381, 6.109, 230),
  airport(17, "VIE", "Vienna International", "Vienna", "AT", "Austria", "🇦🇹", 48.1103, 16.5697, 370),
  airport(18, "PRG", "Prague Václav Havel", "Prague", "CZ", "Czechia", "🇨🇿", 50.1008, 14.26, 200),
  airport(19, "WAW", "Warsaw Chopin", "Warsaw", "PL", "Poland", "🇵🇱", 52.1657, 20.9671, 260),
  airport(20, "BUD", "Budapest Ferenc Liszt", "Budapest", "HU", "Hungary", "🇭🇺", 47.4369, 19.2556, 190),
  airport(21, "CPH", "Copenhagen", "Copenhagen", "DK", "Denmark", "🇩🇰", 55.618, 12.6508, 360),
  airport(22, "ARN", "Stockholm Arlanda", "Stockholm", "SE", "Sweden", "🇸🇪", 59.6519, 17.9186, 300),
  airport(23, "OSL", "Oslo Gardermoen", "Oslo", "NO", "Norway", "🇳🇴", 60.1976, 11.1004, 310),
  airport(24, "HEL", "Helsinki-Vantaa", "Helsinki", "FI", "Finland", "🇫🇮", 60.3172, 24.9633, 220),
  airport(25, "KEF", "Keflavík International", "Reykjavík", "IS", "Iceland", "🇮🇸", 63.985, -22.6056, 90),
  airport(26, "MAD", "Adolfo Suárez Madrid-Barajas", "Madrid", "ES", "Spain", "🇪🇸", 40.4983, -3.5676, 540),
  airport(27, "BCN", "Barcelona El Prat", "Barcelona", "ES", "Spain", "🇪🇸", 41.2974, 2.0833, 470),
  airport(28, "AGP", "Málaga-Costa del Sol", "Málaga", "ES", "Spain", "🇪🇸", 36.6749, -4.4991, 230),
  airport(29, "PMI", "Palma de Mallorca", "Palma", "ES", "Spain", "🇪🇸", 39.5517, 2.7388, 290),
  airport(30, "LIS", "Lisbon Humberto Delgado", "Lisbon", "PT", "Portugal", "🇵🇹", 38.7742, -9.1342, 300),
  airport(31, "OPO", "Porto Francisco Sá Carneiro", "Porto", "PT", "Portugal", "🇵🇹", 41.2481, -8.6814, 140),
  airport(32, "FCO", "Rome Fiumicino", "Rome", "IT", "Italy", "🇮🇹", 41.8003, 12.2389, 420),
  airport(33, "MXP", "Milan Malpensa", "Milan", "IT", "Italy", "🇮🇹", 45.6306, 8.7281, 320),
  airport(34, "VCE", "Venice Marco Polo", "Venice", "IT", "Italy", "🇮🇹", 45.5053, 12.3519, 150),
  airport(35, "NAP", "Naples International", "Naples", "IT", "Italy", "🇮🇹", 40.886, 14.2908, 140),
  airport(36, "CTA", "Catania-Fontanarossa", "Catania", "IT", "Italy", "🇮🇹", 37.4668, 15.0664, 110),
  airport(37, "MLA", "Malta International", "Valletta", "MT", "Malta", "🇲🇹", 35.8575, 14.4775, 90),
  airport(38, "ATH", "Athens International", "Athens", "GR", "Greece", "🇬🇷", 37.9364, 23.9445, 310),
  airport(39, "SKG", "Thessaloniki Makedonia", "Thessaloniki", "GR", "Greece", "🇬🇷", 40.5197, 22.9709, 90),
  airport(40, "HER", "Heraklion Nikos Kazantzakis", "Heraklion", "GR", "Greece", "🇬🇷", 35.3397, 25.1803, 110),
  airport(41, "RHO", "Rhodes Diagoras", "Rhodes", "GR", "Greece", "🇬🇷", 36.4054, 28.0862, 70),
  airport(42, "GPA", "Patras Araxos", "Patras", "GR", "Greece", "🇬🇷", 38.1511, 21.4256, 3),
  airport(43, "IST", "Istanbul Airport", "Istanbul", "TR", "Türkiye", "🇹🇷", 41.2753, 28.7519, 650),
  airport(44, "SAW", "Istanbul Sabiha Gökçen", "Istanbul", "TR", "Türkiye", "🇹🇷", 40.8986, 29.3092, 330),
  airport(45, "AYT", "Antalya", "Antalya", "TR", "Türkiye", "🇹🇷", 36.8987, 30.8005, 260),
  airport(46, "LCA", "Larnaca International", "Larnaca", "CY", "Cyprus", "🇨🇾", 34.8751, 33.6249, 90),
  airport(47, "TLV", "Tel Aviv Ben Gurion", "Tel Aviv", "IL", "Israel", "🇮🇱", 32.0114, 34.8867, 250),
  airport(48, "CAI", "Cairo International", "Cairo", "EG", "Egypt", "🇪🇬", 30.1219, 31.4056, 280),
  airport(49, "RAK", "Marrakech Menara", "Marrakech", "MA", "Morocco", "🇲🇦", 31.6069, -8.0363, 80),
  airport(50, "OTP", "Bucharest Henri Coandă", "Bucharest", "RO", "Romania", "🇷🇴", 44.5711, 26.085, 180),
  airport(51, "SOF", "Sofia", "Sofia", "BG", "Bulgaria", "🇧🇬", 42.6952, 23.4062, 100),
  airport(52, "BEG", "Belgrade Nikola Tesla", "Belgrade", "RS", "Serbia", "🇷🇸", 44.8184, 20.3091, 130),
  airport(53, "ZAG", "Zagreb Franjo Tuđman", "Zagreb", "HR", "Croatia", "🇭🇷", 45.7429, 16.0688, 70),
  airport(54, "DBV", "Dubrovnik", "Dubrovnik", "HR", "Croatia", "🇭🇷", 42.5614, 18.2682, 50),
  airport(55, "DXB", "Dubai International", "Dubai", "AE", "United Arab Emirates", "🇦🇪", 25.2532, 55.3657, 560),
  airport(56, "DOH", "Doha Hamad International", "Doha", "QA", "Qatar", "🇶🇦", 25.2731, 51.6081, 350),
  airport(57, "JFK", "New York John F. Kennedy", "New York", "US", "United States", "🇺🇸", 40.6413, -73.7781, 620),
  airport(58, "ATL", "Hartsfield-Jackson Atlanta International", "Atlanta", "US", "United States", "🇺🇸", 33.6407, -84.4277, 1050),
  airport(59, "ORD", "Chicago O'Hare", "Chicago", "US", "United States", "🇺🇸", 41.9742, -87.9073, 980),
  airport(60, "LAX", "Los Angeles International", "Los Angeles", "US", "United States", "🇺🇸", 33.9416, -118.4085, 780),
  airport(61, "AHN", "Athens Ben Epps", "Athens", "US", "United States", "🇺🇸", 33.9486, -83.3263, 4),
  airport(62, "SIN", "Singapore Changi", "Singapore", "SG", "Singapore", "🇸🇬", 1.3644, 103.9915, 520),
  airport(63, "HND", "Tokyo Haneda", "Tokyo", "JP", "Japan", "🇯🇵", 35.5494, 139.7798, 600),
  airport(64, "KTM", "Kathmandu Tribhuvan International", "Kathmandu", "NP", "Nepal", "🇳🇵", 27.6966, 85.3591, 190),
];

export const findStubAirport = (iata: string): Airport => {
  const match = stubAirports.find((a) => a.iata === iata);
  if (!match) throw new Error(`Unknown stub airport: ${iata}`);
  return match;
};
